export const GOVERNANCE_CONTRACT_ADDRESS = '0x4DEcA517D6817B6510798b7328F2314d3003AbAC';
//# sourceMappingURL=constants.js.map